import dynamic from "next/dynamic";

export const DynamicContent083 = dynamic(() => import("./Content083"), {
  suspense: true,
});
